<template>
  <div class="blogList">
    <h1 class="blogList__title" v-if="title">{{ title }}</h1>
    <div class="blogList__list">
      <div :key="index" class="blogList__listItem" v-for="(item, index) in items">
        <blog-tile :item="item" />
      </div>
      <div class="blogList__pagination">
        <pagination
          :pagination="pagination"
          light-version
          center
          use-href
          :route-name="routeName"
          :route-pagination-name="routePaginationName"
          class="blogList__resultPagination"
          list-with-newsletter
          @change="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlogTile from '~/components/Blog/BlogTile';
import VButton from '~/components/VButton';
import Pagination from '~/components/Pagination';

export default {
  name: 'BlogList',
  components: {
    BlogTile,
    VButton,
    Pagination,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    routeName: {
      type: String,
      default: 'blog',
    },
    routePaginationName: {
      type: String,
      default: 'blog-page-number',
    },
    pagination: {
      type: Object,
      default: () => ({ limit: '12', offset: 0, countTotal: 0 }),
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    changePage(pageNum) {
      if (pageNum < 2) {
        history.pushState({}, null, this.localePath({ name: this.routeName }));
      } else {
        history.pushState(
          {},
          null,
          this.localePath({ name: this.routePaginationName, params: { number: pageNum } }),
        );
      }
      this.changePagination({
        value: { ...this.pagination, offset: (parseInt(pageNum) - 1) * this.pagination.limit },
      });
    },
  },
};
</script>

<style lang="scss">
.blogList {
  margin-top: 4.8rem;

  &__title {
    margin-bottom: 5rem;
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px;
  }

  &__listItem {
    margin-bottom: 4rem;
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
    padding: 0 8px;

    @include rwd('large-tablet') {
      flex: 0 0 33.333%;
      max-width: 33.333%;
    }

    @include rwd('tablet') {
      flex: 0 0 50%;
      max-width: 50%;
    }

    @include rwd('large-phone') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__button {
    padding-top: 1rem;
    text-align: center;
  }

  &__pagination {
    width: 100%;
  }
}
</style>
